import * as XLSX from 'xlsx';

/**
 * Takes an array of sheet definitions and triggers an .xlsx download.
 * @param {Array<{ name: string, data: Array<Array<any>> }>} sheets
 * @param {string} fileName - File name including .xlsx extension
 */
export const downloadExcel = (sheets, fileName) => {
  const workbook = XLSX.utils.book_new();

  sheets.forEach(({ name, data }) => {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, name.slice(0, 31));
  });

  XLSX.writeFile(workbook, fileName);
};
